var _a;
import * as tslib_1 from "tslib";
import { reduxKey } from './constants';
import { setFirstTimeFlags, dropFirstTimeFlag, } from './actions';
export default (_a = {},
    _a[reduxKey] = function (state, action) {
        if (state === void 0) { state = {}; }
        if (action.type === setFirstTimeFlags.toString()) {
            var payload = action.payload;
            if (!payload) {
                return state;
            }
            return tslib_1.__assign({}, state, payload);
        }
        else if (action.type === dropFirstTimeFlag.toString()) {
            var payload = action.payload;
            var newState = tslib_1.__assign({}, state);
            delete newState[payload.flag];
            return newState;
        }
        return state;
    },
    _a);
//# sourceMappingURL=reducers.js.map